import { NgModule } from '@angular/core';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { HttpModule } from '@angular/http';
import {Injectable, Inject} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import { FormsModule }   from '@angular/forms';
// Import your library
import { NgxPermissionsModule, NgxPermissionsGuard  } from 'ngx-permissions';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { API_URL } from './globals';
import { AuthGuard } from './auth-guard.service';
import { AuthService } from './auth.service';


// Import Containers
import {
  FullLayoutComponent,
  FullStaffLayoutComponent,
  SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: SimpleLayoutComponent,
    data: {
      title: 'PublicPages'
    },
    children: [
      {
        path: 'login',
        loadChildren: './views/login/login.module#LoginModule'
      },
      {
        path: 'forgot',
        loadChildren: './views/forgot/forgot.module#ForgotModule'
      },
      {
        path: 'resetpassword/:id/:token',
        loadChildren: './views/resetpwd/resetpwd.module#ResetpwdModule'
      },
      {
        path: 'verify-email/:id/:token',
        loadChildren: './views/verify/verify.module#VerifyModule'
      }
    ]
  },
  {
    path: '',
    data: {
      title: 'Home'
    },
    children: [
      
      {
        path: 'dashboard',
        component: FullLayoutComponent,        
        canActivate: [AuthGuard],
        data: {
          nav:"dashboard"
        },
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },

      {
        path: 'calendar',
        component: FullLayoutComponent,
        // canActivate: [NgxPermissionsGuard],
        // data: {
        //   permissions: {
        //     only: ['ADMIN','TRAINER','DEALER','SUPPLIER','BDR','PRODCORD'],
        //     except: 'GUEST'
        //   }
        // },
        canActivate: [AuthGuard],
        data: {
          nav:"calendar"
        },
        loadChildren: './views/cal/cal.module#CalModule'
      },
     {
        path: 'calendar/:id',
        component: FullLayoutComponent,
        // canActivate: [NgxPermissionsGuard],
        // data: {
        //   permissions: {
        //     only: ['ADMIN','TRAINER','DEALER','SUPPLIER','BDR','PRODCORD'],
        //     except: 'GUEST'
        //   }
        // },
        canActivate: [AuthGuard],
        data: {
          nav:"calendar"
        },
        loadChildren: './views/cal/cal.module#CalModule'
      }, 

	  
	  {
        path: 'project-status',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          nav:"eventstatus"
        },
        loadChildren: './views/projectstatus/projectstatus.module#ProjectstatusModule'
      },
	  
	  {
        path: 'contract-content',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          nav:"contracts"
        },
        loadChildren: './views/contractcontent/contractcontent.module#ContractcontentModule'
      },
	  
	   {
        path: 'email-content',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          nav:"emailcontent"
        },
        loadChildren: './views/emailcontent/emailcontent.module#EmailcontentModule'
      },
	  
	  {
        path: 'intrash',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          nav:"globaltrash"
        },
        loadChildren: './views/intrash/intrash.module#IntrashModule'
      },

      {
        path: 'events',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          nav:"events"
        },
        loadChildren: './views/events/events.module#EventsModule'
      },

      {
         path: 'dealers',     
         component: FullLayoutComponent, 
         canActivate: [AuthGuard],
         data: {
          nav:"dealers"
        },
         loadChildren: './views/dealers/dealers.module#DealersModule'
      },

        
      {
         path: 'staff',     
         component: FullLayoutComponent,
         canActivate: [AuthGuard],
        data: {
          nav:"staff"
        },
         loadChildren: './views/staff/staff.module#StaffModule'
      },

      {
         path: 'packages',     
         component: FullLayoutComponent,
         canActivate: [AuthGuard],
        data: {
          nav:"package"
        },
         loadChildren: './views/packages/packages.module#PackagesModule'
      },

      {
         path: 'brand',
  	     component: FullLayoutComponent,
         canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
         loadChildren: './views/brand/brand.module#BrandModule'
      },

    	{
         path: 'oem',
  	     component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
         loadChildren: './views/oem/oem.module#OemModule'
      },

      {
        path: 'services',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: { nav:"globalproperty"},
        loadChildren: './views/services/services.module#ServicesModule'
      },

      {
        path: 'kittype',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
        loadChildren: './views/kittype/kittype.module#KittypeModule'
      },

	    {
         path: 'auto-group',
  	     component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
         loadChildren: './views/autoGroup/autoGroup.module#AutoGroupModule'
      },

	    {
         path: 'center',
  	     component: FullLayoutComponent,
         canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
         loadChildren: './views/center/center.module#CenterModule'
      },
	  	  
	    {
         path: 'contactrole',
  	     component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
         loadChildren: './views/contactrole/contactrole.module#ContactRoleModule'
      },

	    {
        path: 'mr',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
        loadChildren: './views/mr/mr.module#MrModule'
      },

      {
        path: 'er',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
        loadChildren: './views/er/er.module#ErModule'
      },

	    {
         path: 'advertisingagency',
  	     component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"globalproperty"
        },
         loadChildren: './views/advertisingagency/advertisingagency.module#AdvertisingAgencyModule'
      },

      {
         path: 'country',
         component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"area"
        },
         loadChildren: './views/country/country.module#CountryModule'
      },

       {
         path: 'roles',
         component: FullLayoutComponent,
           canActivate: [AuthGuard],
        data: {
          nav:"acl"
        },
         loadChildren: './views/roles/roles.module#RolesModule'
      },

      {
        path: 'offDays',
        component: FullLayoutComponent,
        loadChildren: './views/offDays/offDays.module#OffDaysModule'
      },

      {
        path: 'holidays',
        component: FullLayoutComponent,
        loadChildren: './views/holidays/holidays.module#HolidaysModule'
      },

      {
         path: 'state',
         component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"area"
        },
         loadChildren: './views/state/state.module#StateModule'
      },
	 {
         path: 'profile',     
         component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"profile"
        },
         loadChildren: './views/profile/profile.module#ProfileModule'
      },
	   {
         path: 'address',     
         component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"address"
        },
         loadChildren: './views/address/address.module#AddressModule'
      },


		{
         path: 'dataupload',     
         component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"dataupload"
        },
         loadChildren: './views/dataupload/dataupload.module#DatauploadModule'
      },
      {
         path: 'dealercontacts',     
         component: FullLayoutComponent,
          canActivate: [AuthGuard],
        data: {
          nav:"dealercontacts"
        },
         loadChildren: './views/dealercontacts/dealercontacts.module#DealercontactsModule'
      },
       {
        path: 'acceptEvent/:eventid/trainer/:memberid',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['TRAINER'],
            except: 'GUEST'
          }
        },
        loadChildren: './views/events/events.module#EventsModule'
      },
       {
        path: 'rejectEvent/:eventid/trainer/:memberid',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['TRAINER'],
            except: 'GUEST'
          }
        },
        loadChildren: './views/events/events.module#EventsModule'
      },
      {
        path: 'acceptEvent/:eventid/dealer/:memberid',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['DEALER'],
            except: 'GUEST'
          }
        },
        loadChildren: './views/events/events.module#EventsModule'
      },

      {
        path: 'acceptEvent/:eventid/supplier/:memberid',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['SUPPLIER'],
            except: 'GUEST'
          }
        },
        loadChildren: './views/events/events.module#EventsModule'
      },


      
      {
        path: 'emails',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['ADMIN','PRODCORD','BDR']
          }
        },
        loadChildren: './views/emails/emails.module#EmailsModule'
      },
      {
        path: 'eventinvoice',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['ADMIN','PRODCORD','BDR']
          }
        },
        loadChildren: './views/eventinvoice/eventinvoice.module#EventinvoiceModule'
      },
      {
        path: 'production',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['ADMIN','PRODCORD','BDR']
          }
        },
        loadChildren: './views/production/production.module#ProductionModule'
      },
      {
        path: 'bestfield',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['ADMIN','PRODCORD','BDR']
          }
        },
        loadChildren: './views/bestfield/bestfield.module#BestfieldModule'
      },

      {
        path: 'invoices',
        component: FullLayoutComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: 'TRAINER'
          }
        },
        loadChildren: './views/invoices/invoices.module#InvoicesModule'
      },

      /*{
        path: 'base',
        component: FullStaffLayoutComponent,
        loadChildren: './views/base/base.module#BaseModule'
      },
      {
        path: 'buttons',
        loadChildren: './views/buttons/buttons.module#ButtonsModule'
      },
      {
        path: 'charts',
        loadChildren: './views/chartjs/chartjs.module#ChartJSModule'
      },
      
      {
        path: 'editors',
        loadChildren: './views/editors/editors.module#EditorsModule'
      },
      {
        path: 'forms',
        loadChildren: './views/forms/forms.module#FormsModule'
      },
      {
        path: 'google-maps',
        loadChildren: './views/google-maps/google-maps.module#GoogleMapsModule'
      },
      {
        path: 'icons',
        loadChildren: './views/icons/icons.module#IconsModule'
      },
      {
        path: 'notifications',
        loadChildren: './views/notifications/notifications.module#NotificationsModule'
      },
      {
        path: 'plugins',
        loadChildren: './views/plugins/plugins.module#PluginsModule'
      },
      {
        path: 'tables',
        loadChildren: './views/tables/tables.module#TablesModule'
      },
      {
        path: 'theme',
        loadChildren: './views/theme/theme.module#ThemeModule'
      },
      {
        path: 'uikits',
        loadChildren: './views/uikits/uikits.module#UIKitsModule'
      },
      {
        path: 'widgets',
        loadChildren: './views/widgets/widgets.module#WidgetsModule'
      }
*/

    ]
  },
  {
    path: 'pages',
    component: SimpleLayoutComponent,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: '',
        loadChildren: './views/pages/pages.module#PagesModule',
      }
    ]
  }
];


@NgModule({
  imports: [ RouterModule.forRoot(routes), HttpModule ],
  exports: [ RouterModule, 
        NgxPermissionsModule ],
  providers: [
    AuthGuard,
    AuthService
  ]
})
export class AppRoutingModule {

  constructor(private NgxRolesService: NgxRolesService, private NgxPermissionsService: NgxPermissionsService, private http: Http, private router:Router) {
    NgxPermissionsService.loadPermissions(["A"]);
    this.NgxRolesService.addRole("GUEST", ['A'] );


    if(localStorage.getItem('currentUserRoleId') == "1"){
      localStorage.setItem('currentUserRole', "ADMIN");
    } else if(localStorage.getItem('currentUserRoleId') == "2"){
      localStorage.setItem('currentUserRole', "TRAINER");
    } else if(localStorage.getItem('currentUserRoleId') == "3"){
      localStorage.setItem('currentUserRole', "REGIONAL");
    } else if(localStorage.getItem('currentUserRoleId') == "4"){
      localStorage.setItem('currentUserRole', "ACCOUNT");
    } else if(localStorage.getItem('currentUserRoleId') == "5"){
      localStorage.setItem('currentUserRole', "DEALER");
    } else if(localStorage.getItem('currentUserRoleId') == "6"){
      localStorage.setItem('currentUserRole', "SUPPLIER");
    } else if(localStorage.getItem('currentUserRoleId') == "7"){
      localStorage.setItem('currentUserRole', "BDR");
    } else if(localStorage.getItem('currentUserRoleId') == "8"){
      localStorage.setItem('currentUserRole', "PRODCORD");
    }

      this.NgxRolesService.flushRoles();

      this.NgxRolesService.addRole(localStorage.getItem('currentUserRole'), ['A']  );

    this.router.events.subscribe((evt:any) => {
      //  console.log(evt);
      if (!(evt instanceof NavigationStart)) {
        if(evt.url == '/' || evt.url == '/login') {
            localStorage.setItem('previousUrl','calendar');
        } else {
            localStorage.setItem('previousUrl',evt.url);        
        }
      } 
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });

  }
}



// WEBPACK FOOTER //
// /var/www/portal/bullseye/src/app/app.routing.ts